import { clearStorage } from './storage/storage'

export const resetAll = () => {
	clearStorage()
	window?.location.assign(new URL('/', window.location.origin))
}
